<template>
  <section id="intro">
    <div class="row clearfix">
      <article id="ceomessage" class="letter clearfix">
        <h1>Introduction:<br>2019 and 2020 Ticket Attendance and Revenue Report (digital report)</h1>

        <div class="sixcol">
          <p>Live Performance Australia (LPA) takes great pleasure in presenting our Ticket Attendance and Revenue Report for 2019 and 2020 (“Report”).</p>
          <p>This is our 16th Report and in the midst of a global pandemic, it has never been more important to have this data to show the impact on the live performance industry. Our reports are the principal source of reliable industry statistics for the Australian live performance industry, and represent the most comprehensive information on annual ticket sales for Australian live performance events available. As the leading source for industry results and trends, the Report is drawn upon extensively by the industry, government, media and business. </p>
          <p>The 2019 and 2020 Report shows that the impact of the global COVID-19 pandemic on the Australian live performance industry has been unprecedented. Following a record year in 2018, the live performance industry recorded its second highest revenue, attendance and average ticket price in 2019. In 2019, nearly 24 million tickets were issued to live performance events, generating total ticket sales revenue of $2.0 billion. In 2020, the number of tickets issued to live performance events fell by 68% to under 8 million, and ticket sales revenue fell by 69% to $600 million. </p>
          <p>In 2019, the different genre categories experienced varying shifts in growth and decline. This trend is consistent with previous years and is primarily due to the impact of major tours or events, particularly international tours, in the market. Unsurprisingly, in 2020, all genre categories experienced a decline. </p>
        </div>
        <div class="sixcol last">
          <p>We encourage you to explore this digital report in depth. The data and commentary is broken down by both
            <router-link :to="{name:'States'}">state</router-link> and <router-link :to="{name:'Categories'}">genre</router-link>
            categories, providing a detailed analysis of the diverse and dynamic Australian live performance market.
            Genre categories include
            <router-link :to="{name:'Category', params:{catId:'ballet-dance'}}">ballet and dance</router-link>,
            <router-link :to="{name:'Category', params:{catId:'children-family'}}">children’s/family events</router-link>,
            <router-link :to="{name:'Category', params:{catId:'circus-physical-theatre'}}">circus and physical theatre</router-link>,
            <router-link :to="{name:'Category', params:{catId:'classical-music'}}">classical music</router-link>,
            <router-link :to="{name:'Category', params:{catId:'comedy'}}">comedy</router-link>,
            <router-link :to="{name:'Category', params:{catId:'contemporary-music'}}">contemporary music</router-link>,
            <router-link :to="{name:'Category', params:{catId:'festivals-multi-category'}}">festivals (multi-category)</router-link>,
            <router-link :to="{name:'Category', params:{catId:'festivals-single-category'}}">festivals (contemporary music)</router-link>,
            <router-link :to="{name:'Category', params:{catId:'musical-theatre'}}">musical theatre</router-link>,
            <router-link :to="{name:'Category', params:{catId:'opera'}}">opera</router-link>,
            <router-link :to="{name:'Category', params:{catId:'special-events'}}">special events</router-link>,
            and
            <router-link :to="{name:'Category', params:{catId:'theatre'}}">theatre</router-link>.
          </p>
          <p>The development of LPA’s research reports, integral to promoting the value and importance of our industry, is made possible by the provision of data by our data participants, including ticketing companies, self-ticketing venues, event promoters and the Australia Council for the Arts on behalf of the Australian Major Performing Arts Group / National Performing Arts Partnership companies. The generous cooperation and effort of all data participants is, as always, greatly appreciated.</p>
          <p>We also thank our Report Consultants, <a target="_blank" href="http://www.ey.com/au/en/home">EY</a>, for their professional services in compiling and analysing the ticket data,
            and our Web Designers, <a target="_blank" href="https://paolismith.com.au/">Paoli Smith</a>, for their preparation of the Digital Report.
            We hope you find the digital format informative and intuitive, allowing ease of comparison with previous year’s data and tracking of trends.</p>
          <p>
            <img src="@/assets/img/2018/ceosignature.jpg" alt="Evelyn Richardson"><br>
            <strong>Evelyn Richardson<br>
            Chief Executive<br>
            Live Performance Australia<br><br>
            October 2021</strong>
          </p>
        </div>
        <div class="twelvecol last">
        </div>
      </article>

      <h1 id="download">Download the Report</h1>

      <div class="execsumm" style="justify-content: center;">
        <a href="./pdf/Live%20Performance%20Industry%20in%20Australia%202019%20and%202020_Final_08%20October%202021%5B2%5D.pdf" class="button fullreport pdf" target="_blank">
          LPA Ticket Attendance and Revenue Report 2019 and 2020 (PDF)
        </a>
      </div>
    </div>
    <div class="fullbg">
      <p class="caption">Photo: <em>Così fan tutte</em>, West Australian Opera, Photo Credit: James Rogers</p>

      <div class="overlay"></div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped="scoped">
#intro .fullbg {
  background-image: url(~@/assets/img/2019/Cos%C3%AC-fan-tutte%2C-West-Australian-Opera%2C-James-Rogers_SFW.jpg);
}
</style>
